import { all, put, takeEvery, call, select } from 'redux-saga/effects';
import { reset } from 'redux-form';
import { MFA_SETUP_VERIFICATION_FORM } from 'modules/auth/components/MfaPanel/constants';
import {
  setupPhoneNumberFail,
  setupPhoneNumberSuccess,
} from '../../../components/MfaPanel/actions';
import { getUserId } from '../../../selectors';
import { getUpdatedUserRequest } from '../../../../menu/actions';
import * as notificationsActions from 'modules/notifications/actions';
import {
  showSetupPhoneNumberErrorMessage,
  showSendSmsVerificationSuccessMessage,
  showSendSmsVerificationErrorMessage,
  showSetupPhoneNumberSuccessMessage,
  showSetupMfaErrorMessage,
} from 'utils/saga/mfa';
import { sendSmsVerificationFail, sendSmsVerificationSuccess } from '../../../actions';
import { authSetupMfaFail, authSetupMfaSuccess } from '../actions';
import { handleSignInStatus } from 'utils/saga/auth';
import { redirectToDashboard } from '../../SignIn/sagas';

function* handleAuthSetupMfaFail(action) {
  yield call(showSetupMfaErrorMessage, action);
}

function* getUser(action) {
  const userId = yield select(getUserId);
  yield put(getUpdatedUserRequest(userId));
  yield call(redirectToDashboard, action);
}

function* handleAuthSetupSuccess(action) {
  yield put(
    notificationsActions.showNotificationInfo({
      key: 'auth:mfa.notifications.enable.success',
    }),
  );
  yield put(reset(MFA_SETUP_VERIFICATION_FORM));
  yield call(handleSignInStatus, { action, successCallback: getUser });
}

function* handleSetupPhoneNumberSuccess() {
  yield call(showSetupPhoneNumberSuccessMessage);
}

function* handleSetupPhoneNumberFail(action) {
  yield call(showSetupPhoneNumberErrorMessage, action);
}

function* handleSendSmsVerificationSuccess() {
  yield call(showSendSmsVerificationSuccessMessage);
}

function* handleSendSmsVerificationFail(action) {
  yield call(showSendSmsVerificationErrorMessage, action);
}

export default function* watchRequest() {
  yield all([
    takeEvery(authSetupMfaSuccess, handleAuthSetupSuccess),
    takeEvery(authSetupMfaFail, handleAuthSetupMfaFail),
    takeEvery(setupPhoneNumberSuccess, handleSetupPhoneNumberSuccess),
    takeEvery(setupPhoneNumberFail, handleSetupPhoneNumberFail),
    takeEvery(sendSmsVerificationSuccess, handleSendSmsVerificationSuccess),
    takeEvery(sendSmsVerificationFail, handleSendSmsVerificationFail),
  ]);
}
